/** Content hashes earlier saves were sealed with. Alpha content changes are additive, so they load and reseal. */
export const PREVIOUS_CONTENT = ['e115bb41', '31e6a596', '6e507918', 'c4c1af58', '4d858eee', '27ff17be', '6a9ad4b1', '3cd0b062'] as const;

export function compatibleSaveHash(savedHash: string, currentHash: string): boolean {
    return savedHash === currentHash || (PREVIOUS_CONTENT as readonly string[]).includes(savedHash) && !(PREVIOUS_CONTENT as readonly string[]).includes(currentHash);
}
